import React from 'react'

const Footer = () => {
  return (
    <footer className='w-full h-full bg-black px-6 py-6'>

        <div className='w-10/12 mx-auto grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4'>
            {/* section one */}
        <div>
            <h1 className='font-semibold text-white border-b-4 inline border-sky-400 text-xl'>Products</h1>
            <ul className='text-white space-y-2 pt-4'>
                <li>App</li>
                <li>Analytics</li>
                <li>Token List</li>
                <li>Defi</li>
            </ul>
        </div>

        {/* section one */}
        <div>
            <h1 className='font-semibold text-white border-b-4 inline border-sky-400 text-xl'>Products</h1>
            <ul className='text-white space-y-2 pt-4'>
                <li>App</li>
                <li>Analytics</li>
                <li>Token List</li>
                <li>Defi</li>
            </ul>
        </div>

        {/* section one */}
        <div>
            <h1 className='font-semibold text-white border-b-4 inline border-sky-400 text-xl'>Products</h1>
            <ul className='text-white space-y-2 pt-4'>
                <li>App</li>
                <li>Analytics</li>
                <li>Token List</li>
                <li>Defi</li>
            </ul>
        </div>

        {/* section one */}
        <div>
            <h1 className='font-semibold text-white border-b-4 inline border-sky-400 text-xl'>Products</h1>
            <ul className='text-white space-y-2 pt-4'>
                <li>App</li>
                <li>Analytics</li>
                <li>Token List</li>
                <li>Defi</li>
            </ul>
        </div>

        {/* section one */}
        <div>
            <h1 className='font-semibold text-white border-b-4 inline border-sky-400 text-xl'>Products</h1>
            <ul className='text-white space-y-2 pt-4'>
                <li>App</li>
                <li>Analytics</li>
                <li>Token List</li>
                <li>Defi</li>
            </ul>
        </div>
        </div>
    </footer>
  )
}

export default Footer